import { render } from "./TabGroup.vue?vue&type=template&id=0633c2da"
import script from "./TabGroup.vue?vue&type=script&lang=js"
export * from "./TabGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__